import React from 'react'

const CreateNote = () => {
  return (
    <div>
        <h1>Create Note</h1>
    </div>
  )
}

export default CreateNote